import Debug from 'debug';
import { AuthenticatedApiService } from '../../ui/services/AuthenticatedApi';
import { environment, getUrlsForEnvironment } from '../../environment';

export const urls = getUrlsForEnvironment(environment);

export async function getVideoTranscript(
  api: AuthenticatedApiService,
  videoId: string,
  title: string,
  subtitle: string,
): Promise<{ subtitle: string; title: string; transcript?: string; videoId: string }> {
  const debug = Debug('o365:lib:transcript:getVideoTranscript');

  const url = new URL(`/v2/videos/${videoId}/transcript`, urls.apiUrl);
  debug('getVideoTranscript ', url);

  const response = await api.get(url);
  if (!response) {
    debug('response error');
    // handle error
    return {
      subtitle,
      title,
      videoId,
    };
  }
  const result = await response.json();
  debug(' response success');
  return {
    ...result,
    subtitle,
    title,
    videoId,
  };
}

export async function getVideoTranscriptStatus(
  api: AuthenticatedApiService,
  videoId: string,
): Promise<{ status?: string; videoId: string }> {
  const debug = Debug('o365:lib:transcript:getVideoTranscriptStatus');

  const url = new URL(`/v2/videos/${videoId}/transcript/status`, urls.apiUrl);

  const response = await api.get(url);
  if (!response || !response.status) {
    debug('response error');
    // handle error
    return {
      videoId,
    };
  }

  const result = await response.json();
  debug('response success', result);
  return {
    ...result,
    videoId,
  };
}
